import React from 'react'

interface Props {
  color?: string
  className?: string
}

const RicohLogo: React.FC<Props> = ({ color, className }) => {
  return (
    <div className={className}>
      <svg
        id='logo'
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 594.97 205.83'
        fill={color || '#000'}
      >
        <path
          d='M351.92,246.46c0,20.29,15,35.26,40.13,35.26,10.6,0,20.57-1.66,30.9-6.48l9.41,12.81c-13,6.86-25.5,10.47-44.7,10.47-40.07,0-69.51-19.29-69.51-52v0c0-32.75,29.44-52,69.51-52,19.2,0,30.25,2.8,43.76,8.6l-9.63,14.74c-10.24-5.44-19.14-6.56-29.74-6.56-25.11,0-40.13,15-40.13,35.24'
          transform='translate(-127.41 -194.4)'
        />
        <path
          d='M504.75,194.4C466,194.4,438,213.71,438,246.46s28,52.06,66.74,52.06,66.76-19.29,66.76-52.06-28-52.06-66.76-52.06m0,87.93c-21.33,0-33.11-16-33.11-35.88s11.78-35.87,33.11-35.87,33.12,16,33.12,35.87-11.79,35.88-33.12,35.88'
          transform='translate(-127.41 -194.4)'
        />
        <polygon points='544.91 59.6 544.91 101.49 576.96 101.49 576.96 2.61 544.91 2.61 544.91 40.33 495.92 40.33 495.92 2.61 463.94 2.61 463.94 101.49 495.92 101.49 495.92 59.6 544.91 59.6' />
        <rect x='137.67' y='2.61' width='33.75' height='98.87' />
        <path
          d='M168.28,242.28v9.45a252.7,252.7,0,0,1,43.91,44.16H250c-13.15-15.44-33.31-33.78-48.16-43,17.43-.71,36.86-7.77,36.86-27.78,0-25.67-27.45-30.39-55.18-30.39-22.66,0-43.54,1.05-56.08,2.08v99.12h31.53v-84.2a198.29,198.29,0,0,1,24.69-1.33c16.23,0,24.45,5.37,24.45,14.72,0,8-3.41,17.55-39.8,17.2'
          transform='translate(-127.41 -194.4)'
        />
        <path
          d='M130,325.55H138v7.82H130Zm0,16.12H138V382H130Z'
          transform='translate(-127.41 -194.4)'
        />
        <path
          d='M198.36,382V356.1c0-4.91-1.52-8.94-7.17-8.94-6.61,0-8.94,6.64-8.94,12.85v22h-8.06V356.1c0-4.91-1.54-8.94-7.18-8.94-6.61,0-9,6.64-9,12.85v22h-8.06v-31a89.82,89.82,0,0,0-.4-9.27h7.58l.24,6.93c2.66-5.15,6.85-7.73,12.33-7.73,6.37,0,10.55,3.79,11.77,8.22a13.43,13.43,0,0,1,12.34-8.22c8.77,0,12.72,6,12.72,14.26V382Z'
          transform='translate(-127.41 -194.4)'
        />
        <path
          d='M562.21,382,562,375.6c-5.77,10.77-26,9.64-26-4.27,0-10.47,10-14.77,25.78-14,0-.05.87-7.57-4.32-9.89-3.39-1.51-10.61-1.29-16.71,2.32l-.49-6.2c9.37-3.87,29.43-6.3,29.43,12.37V373a74.76,74.76,0,0,0,.48,9Zm-7.89-5.09c5.91-1.41,7.66-7.38,7.4-14.67,0,0-18.3-1.47-17.81,8.67.29,5.95,6,7.05,10.41,6'
          transform='translate(-127.41 -194.4)'
        />
        <path
          d='M240.85,382l-.24-6.38c-5.77,10.77-26,9.64-26-4.27,0-10.47,10-14.77,25.79-14,0-.05.86-7.57-4.33-9.89-3.39-1.51-10.61-1.29-16.72,2.32l-.48-6.2c9.37-3.87,29.43-6.3,29.43,12.37V373a74.76,74.76,0,0,0,.48,9Zm-7.9-5.09c5.92-1.41,7.67-7.38,7.42-14.67,0,0-18.31-1.47-17.82,8.67.29,5.95,6,7.05,10.4,6'
          transform='translate(-127.41 -194.4)'
        />
        <path
          d='M626.46,398.09l.5-6.85a25.66,25.66,0,0,0,12,2.9c13.94-.22,13.13-11.79,13.13-19.18a15.18,15.18,0,0,1-12.49,7c-11.77,0-16.36-10.25-16.36-20.31,0-10.73,4.59-20.8,16.53-20.8,5.55,0,10.07,2.42,12.65,7.49v-6.69h7.74v38.05c0,22.44-20,22.62-33.7,18.37m15.64-51c-8.3,0-10.15,7.9-10.15,14.67,0,6.28,1.93,14,10.07,14,7.82,0,10.32-7.91,10.32-14,0-6.44-2.42-14.67-10.24-14.67'
          transform='translate(-127.41 -194.4)'
        />
        <path
          d='M260,398.09l.49-6.85a25.73,25.73,0,0,0,12,2.9c13.94-.22,13.14-11.79,13.14-19.18a15.2,15.2,0,0,1-12.49,7c-11.77,0-16.37-10.25-16.37-20.31,0-10.73,4.6-20.8,16.53-20.8,5.56,0,10.07,2.42,12.66,7.49v-6.69h7.72v38.05c0,22.44-20,22.62-33.69,18.37m15.65-51c-8.31,0-10.17,7.9-10.17,14.67,0,6.28,1.94,14,10.08,14,7.82,0,10.32-7.91,10.32-14,0-6.44-2.42-14.67-10.23-14.67'
          transform='translate(-127.41 -194.4)'
        />
        <path
          d='M305.65,325.55h8.05v7.82h-8.05Zm0,16.12h8.05V382h-8.05Z'
          transform='translate(-127.41 -194.4)'
        />
        <path
          d='M677.08,363.92c.48,14.08,13,15.85,24.19,10.47l.48,6.29c-16.19,5.25-33,2.15-33-19,0-11,7-20.79,18.22-20.79,19,0,16.84,23.05,16.84,23.05Zm10-17.5c-6.86,0-10.08,7.34-10.08,12.5h19.11c0-5.73-2.18-12.5-9-12.5'
          transform='translate(-127.41 -194.4)'
        />
        <path
          d='M376.78,363.92c.46,14.08,13,15.85,24.18,10.47l.48,6.29c-16.19,5.25-33,2.15-33-19,0-11,7-20.79,18.22-20.79,19,0,16.84,23.05,16.84,23.05Zm10-17.5c-6.85,0-10.07,7.34-10.07,12.5h19.1c0-5.73-2.17-12.5-9-12.5'
          transform='translate(-127.41 -194.4)'
        />
        <rect x='286.04' y='179.27' width='8.62' height='8.3' />
        <path
          d='M450.55,361.66c0-18.33,17.68-24.23,33.07-19.1l-.49,6.44c-10.08-4.71-23.88-1.77-23.88,12.66,0,14,13.16,18,24,13.22l.4,6.37c-12.76,4.35-33.07,1-33.07-19.59'
          transform='translate(-127.41 -194.4)'
        />
        <path
          d='M514,340.87c-5.64,0-10,2.5-12.49,7.49V325.55h-8.06V382h8.06v-21.1c0-6.29,2.42-13.71,9.84-13.71,6.92,0,8,5.29,8,11V382h8.13V356.5c0-9.19-3.78-15.63-13.46-15.63'
          transform='translate(-127.41 -194.4)'
        />
        <path
          d='M606.47,382V358.2c0-5.64-1.05-11-8-11-7.48,0-9.82,6.82-9.82,13.18V382H580.6v-31a87.12,87.12,0,0,0-.41-9.27h7.58l.24,6.93a14.06,14.06,0,0,1,13.06-7.73c10,0,13.54,6.37,13.54,15.63V382Z'
          transform='translate(-127.41 -194.4)'
        />
        <path
          d='M351.7,382V358.2c0-5.64-1-11-8-11-7.49,0-9.83,6.82-9.83,13.18V382h-8.06v-31a87.12,87.12,0,0,0-.41-9.27H333l.25,6.93a14.05,14.05,0,0,1,13.05-7.73c10,0,13.54,6.37,13.54,15.63V382Z'
          transform='translate(-127.41 -194.4)'
        />
        <rect x='586.35' y='179.26' width='8.62' height='8.31' />
      </svg>
    </div>
  )
}

RicohLogo.displayName = 'RicohLogo'

export default RicohLogo
